import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, MessageCircle, FileText } from 'lucide-react';
import './MobileBottomBar.css';

const MobileBottomBar = () => {
  const location = useLocation();
  const isServicePage = location.pathname.startsWith('/services/');

  if (!isServicePage) return null;

  return (
    <div className="mobile-bar" role="navigation" aria-label="Quick actions">
      <a href="tel:+919940689572" className="mobile-bar__item" aria-label="Call us">
        <Phone size={18} />
        <span>Call</span>
      </a>
      <a
        href="https://wa.me/919940689572"
        className="mobile-bar__item mobile-bar__item--wa"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp us"
      >
        <MessageCircle size={18} />
        <span>WhatsApp</span>
      </a>
      <Link to="/quote" className="mobile-bar__item mobile-bar__item--quote" aria-label="Request a quote">
        <FileText size={18} />
        <span>Quote</span>
      </Link>
    </div>
  );
};

export default MobileBottomBar;
